
import { t } from '@/locales/index'

export default {
  props: ['project'],
  setup() {
    return { t }
  },
}
